<template>
  <component
    :is="require(`@/components/connectors/${fileName}.svg`)"
    :class="{ reversed: reversed }"
  />
</template>

<script>
export default {
  name: 'BaseConnector',
  props: {
    type: {
      type: String,
      required: true,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    os2: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fileName() {
      let apcSuffix = '';
      let os2Suffix = '';
      let file = this.type.toLowerCase();
      if (file === 'nu') {
        return 'nu';
      }
      if (this.isApc) {
        apcSuffix = '-apc';
        file = file.substring(0, 2);
      }
      if (this.os2 && this.type !== 'ST') { os2Suffix = '-os2'; }
      return `${file}${apcSuffix}${os2Suffix}`;
    },
    isApc() {
      return this.type === 'LC/APC' || this.type === 'SC/APC';
    },
  },
};
</script>

<style lang="scss" scoped>
.reversed {
  transform: rotate(180deg);
}
</style>
